export default function getSelectionText(editorState) {
  const selectionState = editorState.getSelection();
  if (selectionState.isCollapsed()) {
    return "";
  }
  const startKey = selectionState.getStartKey();
  const currentContent = editorState.getCurrentContent();
  const currentBlock = currentContent.getBlockForKey(startKey);

  const start = selectionState.getStartOffset();
  const end = selectionState.getEndOffset();
  const selectionText = currentBlock.getText().slice(start, end);
  return selectionText;
}
